import { Pipe, PipeTransform } from '@angular/core';
import { savingsPercentage } from '../../../../../../aptitude/src/main/webapp/src/typescript/modules/planning/details/model/shared-calculations';

@Pipe({
    name: 'savingsPercentage',
    standalone: false
})
export class SavingsPercentagePipe implements PipeTransform {
  transform(plan: any): string {
    const percentage = savingsPercentage(
      plan.continuedSpend,
      plan.plannedSpend,
    );
    return percentage > 0
      ? `${Math.round(percentage)}% Spend Decrease`
      : `${Math.round(percentage) * -1}% Spend Increase`;
  }
}
